// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3PjRb","title":"AfterBackImages_title__1_hD9","images":"AfterBackImages_images__2jKmM"};